export default __webpack_public_path__ + "static/media/39.f5640991.jpeg";